import React from 'react';

import style from './startScreen.css';

const LoadBar = ({ loadingProgress, startLoading }) => (
  <div className={`${style.loadBar} ${style.stagger}`}>
    <div className={style.loadValue} style={{ width: `${loadingProgress * 100}%` }} />
    <div className={`${style.loadMessage} ${startLoading ? style.fadeIn : null}`}>LOADING</div>
  </div>
);

const PlayButton = ({ onStartPlayer, startLoading, loadingPage, autoplay }) => {
  if (autoplay) return null;
  const className = `${style.playHolder} ${startLoading ? style.hide : ''}`;
  return (
    <div className={className} onClick={onStartPlayer}>
      {loadingPage.startImg ? (
        <img src={loadingPage.startImg} alt="Play button" />
      ) : (
        <svg viewBox="0 0 314.41 314.41" className={style.playButton}>
          <path d="m288.32 145.31l-248.49-143.47c-4.253-2.454-9.486-2.454-13.74 0-4.249 2.452-6.871 6.991-6.871 11.898v286.93c0 4.908 2.622 9.447 6.871 11.898 2.128 1.229 4.5 1.843 6.87 1.843 2.372 0 4.743-0.614 6.87-1.843l248.49-143.46c4.25-2.452 6.871-6.991 6.871-11.898-1e-3 -4.908-2.622-9.446-6.872-11.898z" />
        </svg>
      )}
    </div>
  );
};

const TitleCard = ({ title, subtitle }) => (
  <div className={style.titleCard}>
    <h1 id="title">{!title || title === '' ? 'Activity' : title}</h1>
    <h4 id="subline">{!subtitle || subtitle === '' ? 'Unknown location' : subtitle}</h4>
  </div>
);

const Spacer = () => <div className={style.spacer} />;

const Overlay = props => {
  const className = `${style.startOverlay} 
    ${props.isMobile ? style.mobile : ''} 
    ${props.playerPlaying ? style.hideOverlay : null}`;
  return <div className={className}>{props.children}</div>;
};

const StartPage = ({
  sceneReady,
  playerPlaying,
  onStartPlayer,
  sceneTitle,
  playerStarted,
  loadingProgress,
  loadingPage,
  location,
  autoplay,
  isMobile,
}) => {
  const startLoading = playerStarted || autoplay;
  return sceneReady ? (
    <Overlay {...{ isMobile, playerPlaying }}>
      <img src={loadingPage.background} alt="" className={startLoading ? style.hide : ''} />
      <div className={`${style.contentWrapper}`}>
        <div className={`${style.expansionContainer} ${startLoading ? style.expand : null}`}>
          <TitleCard title={sceneTitle} subtitle={location} />
          <Spacer startLoading={startLoading} />
          <LoadBar loadingProgress={loadingProgress} startLoading={startLoading} />
          <PlayButton {...{ onStartPlayer, startLoading, autoplay, loadingPage }} />
        </div>
      </div>
    </Overlay>
  ) : null;
};

export default StartPage;
